/**
 * @generated SignedSource<<d36896ef00d34da9b3c9730f7ae45078>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type HorizontalNavBoardHeader_project$data = {
  readonly canEditProjectConfig?: {
    readonly canPerform: boolean;
  } | null | undefined;
  readonly created?: AGG$DateTime | null | undefined;
  readonly projectId?: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"NavigationInviteButton_project" | "NavigationTeamButton_project" | "breadcrumbs_horizontalNav_HorizontalNavProjectBreadcrumbs" | "extraComponentsFar_horizontalNav" | "ui_navigationBoardActionMenu_BoardActions">;
  readonly " $fragmentType": "HorizontalNavBoardHeader_project";
};
export type HorizontalNavBoardHeader_project$key = {
  readonly " $data"?: HorizontalNavBoardHeader_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"HorizontalNavBoardHeader_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjirainvitebuttonrelayprovider"
    },
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonrelayprovider"
    },
    {
      "kind": "RootArgument",
      "name": "isTMPBoardRoute"
    }
  ],
  "kind": "Fragment",
  "name": "HorizontalNavBoardHeader_project",
  "selections": [
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "NavigationTeamButton_project"
        }
      ]
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjirainvitebuttonrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "NavigationInviteButton_project"
        },
        {
          "alias": "canEditProjectConfig",
          "args": [
            {
              "kind": "Literal",
              "name": "type",
              "value": "EDIT_PROJECT_CONFIG"
            }
          ],
          "concreteType": "JiraProjectAction",
          "kind": "LinkedField",
          "name": "action",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "canPerform"
            }
          ],
          "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
        },
        {
          "kind": "ScalarField",
          "name": "projectId"
        },
        {
          "kind": "ScalarField",
          "name": "created"
        }
      ]
    },
    {
      "condition": "isTMPBoardRoute",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "ui_navigationBoardActionMenu_BoardActions"
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "extraComponentsFar_horizontalNav"
    },
    {
      "kind": "FragmentSpread",
      "name": "breadcrumbs_horizontalNav_HorizontalNavProjectBreadcrumbs"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "5fd7671c31c6e8515594a670eee7c62f";

export default node;
